import { useCustomToast } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { useQueryWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { useIsLoggedIn } from 'hooks/use-is-logged-in';
import { UseQueryOptions, UseQueryResult } from 'react-query';
import { ReconciliationSupplierDetail } from './types';

const getEndpoint = (supplierId: number) => `ums/v1/cms/reconciliation/suppliers/${supplierId}`;

type TData = ReconciliationSupplierDetail;
type TError = AxiosError;
type TQueryKey = ['reconciliation-supplier-details', string, number | null];
type Options = Omit<UseQueryOptions<unknown, TError, TData, TQueryKey>, 'queryKey' | 'queryFn'>;
type ReturnType = UseQueryResult<TData, TError>;

export function useGetReconciliationSupplierDetailsApi(
  month: string,
  supplierId: number | null,
  options?: Options
): ReturnType {
  const toast = useCustomToast();
  const isLoggedIn = useIsLoggedIn();

  const queryFn = async () => {
    try {
      const { data } = await http.get(getEndpoint(supplierId as number), { params: { month } });
      return data;
    } catch (error: any) {
      if (!error.response?.status || !error.response?.data?.message) throw error;

      toast({
        description: error.response.data.message,
        status: 'error',
      });

      throw error;
    }
  };

  return useQueryWrapper(['reconciliation-supplier-details', month, supplierId], queryFn, {
    enabled: isLoggedIn && !!month && !!supplierId,
    ...options,
  });
}
